/**
 * Per-user checkout preference helpers.
 * Preferences are stored in localStorage keyed by user ID so each
 * account gets its own defaults without interfering with others or guests.
 *
 * Shape of the stored object:
 * {
 *   defaultFulfillmentMethod: 'ship' | 'pickup',
 *   defaultPickupLocation: string,
 *   defaultPhone: string,
 *   defaultPaymentMethod: 'PayPal' | 'PickupPay' | 'Payment at Delivery' | 'End of Month Payment',
 *   defaultShippingAddress: {
 *     address, address2, city, province, postalCode, country
 *   }
 * }
 */

const PREFS_KEY = (uid) => `orderPrefs_${uid}`;

/**
 * Load checkout preferences for a given user.
 * Returns an empty object if nothing is saved or on any error.
 */
export function loadPrefs(userId) {
  if (!userId) return {};
  try {
    const raw = localStorage.getItem(PREFS_KEY(userId));
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

/**
 * Persist checkout preferences for a given user.
 */
export function savePrefs(userId, prefs) {
  if (!userId) return;
  try {
    localStorage.setItem(PREFS_KEY(userId), JSON.stringify(prefs || {}));
  } catch {}
}
